export default "__VITE_ASSET__DwlLx7sq__"